if (!customElements.get("eck-sticky-atc")) {
  customElements.define(
    "eck-sticky-atc",
    class EckStickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.priceTarget = this.querySelector("[data-eck-sticky-price]");
        this.thumbTarget = this.querySelector("[data-eck-sticky-thumb]");
        this.submitButton = this.querySelector("[data-eck-sticky-submit]");
        this.submitText = this.querySelector("[data-eck-sticky-submit-text]");
        this.selects = Array.from(this.querySelectorAll("[data-eck-sticky-select]"));
        this.unsubscribers = [];
      }

      connectedCallback() {
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.variantSelects = document.getElementById(`variant-selects-${this.sectionId}`);

        this.setupReveal();
        this.setupSync();
        this.setupSelects();

        this.submitButton.addEventListener("click", this.onSubmit.bind(this));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.unsubscribers.forEach((fn) => fn());
      }

      setupReveal() {
        const anchor = this.mainButton ? this.mainButton.closest("product-form") : null;
        if (!anchor || !("IntersectionObserver" in window)) {
          return;
        }
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const aboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle("hidden", !aboveViewport);
              if (aboveViewport) {
                this.classList.add("eck-sticky-atc--visible");
              } else {
                this.classList.remove("eck-sticky-atc--visible");
              }
            });
          },
          { threshold: 0 },
        );
        this.observer.observe(anchor);
      }

      setupSync() {
        if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") {
          return;
        }
        this.unsubscribers.push(
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event && event.data;
            if (!data || data.sectionId !== this.sectionId) return;
            this.onVariantChange(data);
          }),
        );
        this.unsubscribers.push(
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            this.submitButton.removeAttribute("disabled");
          }),
        );
      }

      onVariantChange(data) {
        const html = data.html;

        if (this.priceTarget && html) {
          const sourcePrice = html.getElementById(`price-${this.sectionId}`);
          if (sourcePrice) this.priceTarget.innerHTML = sourcePrice.innerHTML;
        }

        if (html) {
          const sourceButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          if (sourceButton) {
            const disabled = sourceButton.hasAttribute("disabled");
            this.submitButton.toggleAttribute("disabled", disabled);
            const label = sourceButton.querySelector("span");
            if (label && this.submitText) this.submitText.textContent = label.textContent.trim();
          }
        }

        if (!data.variant) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (this.submitText && window.variantStrings) this.submitText.textContent = window.variantStrings.unavailable;
        }

        if (this.thumbTarget && data.variant && data.variant.featured_media) {
          const img = this.thumbTarget.querySelector("img");
          if (img) {
            img.src = data.variant.featured_media.preview_image.src;
            img.srcset = "";
          }
        }

        if (data.variant) {
          this.selects.forEach((select, index) => {
            const value = data.variant.options[index];
            if (value != null) select.value = value;
          });
        }
      }

      setupSelects() {
        this.selects.forEach((select) => {
          select.addEventListener("change", () => this.onSelectChange(select));
        });
      }

      onSelectChange(select) {
        if (!this.variantSelects) return;
        const position = parseInt(select.dataset.optionPosition, 10);
        const value = select.value;

        const radios = this.variantSelects.querySelectorAll(
          `input[type="radio"][id^="${this.sectionId}-${position}-"]`,
        );
        let matched = false;
        radios.forEach((radio) => {
          if (radio.value === value) {
            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            matched = true;
          }
        });

        if (!matched) {
          const mainSelect = this.variantSelects.querySelector(`#Option-${this.sectionId}-${position - 1}`);
          if (mainSelect) {
            mainSelect.value = value;
            mainSelect.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      }

      onSubmit() {
        if (this.submitButton.hasAttribute("disabled")) return;
        if (this.mainButton) {
          this.submitButton.setAttribute("disabled", "disabled");
          this.mainButton.click();
        }
      }
    },
  );
}
